export const ASSETS = {
	Zvonecek: "/img/zvonecek.webp",
	KokokykaBlack: "/img/kokokyka/black.webp",
	KokokykaWhite: "/img/kokokyka/white.webp",
	KokokykaBlackWinter: "/img/kokokyka/black-winter.webp",
	KokokykaWhiteWinter: "/img/kokokyka/white-winter.webp",
	PlaceholderImg: "/img/placeholder.webp",
	Logo: "/img/logo.webp",
	Background: "/img/background.webp",
	BackgroundFishes: "/img/background-fishes.webp",
	Christmas: "/img/stromecek.webp",
};

function clearBgClasses() {
	document.body.classList.remove("fish-bg");
	document.body.classList.remove("christmas");
}

export function setDefaultBackground() {
	clearBgClasses();
	document.body.style.background = `url(${ASSETS.Background}) repeat center top fixed`;
}

export function setFishBackground() {
	clearBgClasses();
	document.body.classList.add("fish-bg");
	document.body.style.background = `url(${ASSETS.BackgroundFishes}) center center no-repeat`;
}

export function setChristmasBackgound() {
	clearBgClasses();
	document.body.classList.add("christmas");
	document.body.style.background = `url(${ASSETS.Christmas}) center center no-repeat`;
}
